import React from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { ClientLogos } from "../components/ClientLogos";
import { Marquee } from "../components/Marquee";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { Pricing } from "../components/Pricing";
import { CaseStudiesSection } from "../components/CaseStudiesSection";
import { Process } from "../components/Process";
import { Testimonials } from "../components/Testimonials";
import { WhyWorkWithMe } from "../components/WhyWorkWithMe";
import { FAQ } from "../components/FAQ";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";

export default function Home() {
  const scrollTo = (sel) => {
    const el = document.querySelector(sel);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-cream" data-testid="home-page">
      <Navbar />
      <Hero onCTA={scrollTo} />
      <ClientLogos />
      <Marquee />
      <About />
      <Services />
      <Pricing />
      <CaseStudiesSection />
      <Process />
      <Testimonials />
      <WhyWorkWithMe />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
